import React, { Component } from 'react';
import PropTypes from 'prop-types';
import PageHero from '../../shared/components/PageHero/PageHero';
import breakpointImageUrls from '../../shared/helpers/breakpointImageUrls';


class Banner extends Component {
  static getDomId() {
    return 'search_banner';
  }

  render() {
    const {
      title,
      linkTo,
      imageUrl,
      buttonText,
      bannerTemplate,
      shortDescription,
      markdownDescription,
      coBranding,
      imageAltText,
    } = this.props;
    const imageUrls = breakpointImageUrls(imageUrl);
    const template = bannerTemplate || 'category';

    return (
      <PageHero
        title={title}
        linkTo={linkTo}
        buttonText={buttonText}
        template={template}
        image={imageUrls.desktop}
        imageMobile={imageUrls.mobile}
        subtitle={markdownDescription || shortDescription}
        coBranding={coBranding}
        imageAltText={imageAltText}
      />
    );
  }
}

Banner.defaultProps = {
  title: '',
  linkTo: '',
  imageUrl: '',
  buttonText: '',
  shortDescription: '',
  markdownDescription: '',
  bannerTemplate: 'category',
  coBranding: PropTypes.shape({
    tagline: '',
    imageUrl: '',
    isEnabled: false,
  }),
  imageAltText: '',
};
Banner.propTypes = {
  title: PropTypes.string,
  linkTo: PropTypes.string,
  imageUrl: PropTypes.string,
  buttonText: PropTypes.string,
  bannerTemplate: PropTypes.string,
  shortDescription: PropTypes.string,
  markdownDescription: PropTypes.string,
  coBranding: PropTypes.shape({
    tagline: PropTypes.string,
    imageUrl: PropTypes.string,
    isEnabled: PropTypes.bool,
  }),
  imageAltText: PropTypes.string,
};

export default Banner;
